<template>
    <div class="p-6 bg-indigo-800 min-h-screen flex flex-col justify-center items-center">
        <div class="w-full max-w-md">
            <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
            <form v-if="!otp_sent" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submitForOtp">
                <div class="px-10 py-12">
                    <h1 class="text-center font-bold text-3xl">Forgot Password?</h1>
                    <p class="text-sm leading-normal mt-3">We will send you an OTP to your mobile number if registered. You will need the OTP to set a new password.</p>

                    <text-input v-model="form.mobile" :errors="$page.props.errors.mobile" class="mt-10" maxlength="7" label="Enter registered mobile number" type="tel" pattern='[7,9]{1}[0-9]{6}' autofocus autocapitalize="mobile" />

                    <text-input v-if="otp_sent" v-model="form.otp" :errors="$page.props.errors.otp" class="mt-10" maxlength="6" label="Enter OTP" type="tel" autofocus autocapitalize="one-time-code" />
                </div>
                <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
                    <a :href="route('customer.login')" class="hover:underline" tabindex="-1" href="#reset-password">Go to Login page</a>
                    <loading-button :loading="sending" class="btn-primary" type="submit">Proceed</loading-button>
                </div>
            </form>

            <form v-if="otp_sent" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="verifyOTP">
                <div class="px-10 py-12">
                    <h1 class="text-center font-bold text-3xl">Verify OTP</h1>
                    <p class="text-sm leading-normal mt-3">You will have an sms from us with 6 digit OTP number, please enter it below to verify.</p>

                    <text-input :value="form.mobile" readonly  class="mt-10" maxlength="7" label="Mobile number" type="tel" pattern='[7,9]{1}[0-9]{6}' autofocus autocapitalize="mobile" />

                    <text-input v-model="form.otp" :errors="$page.props.errors.otp" class="mt-10" maxlength="6" label="Enter OTP" type="tel" autofocus autocapitalize="one-time-code" />


                    <p class="text-sm leading-normal mt-3">Set your new password here and confirm the same password</p>
                    <text-input v-model="form.password" class="mt-6" label="Password" type="password" />
                    <text-input v-model="form.password_confirmation" class="mt-6" label="Confirm Password" type="password" :errors="$page.props.errors.password" />
                </div>
                <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
                    <a :href="route('customer.login')" class="hover:underline" tabindex="-1" href="#reset-password">Go to Login page</a>
                    <loading-button :loading="sending" class="btn-primary" type="submit">Verify & Reset Password</loading-button>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
  import LoadingButton from '@/Shared/LoadingButton'
  import Logo from '@/Shared/Logo'
  import TextInput from '@/Shared/TextInput'

  export default {
    metaInfo: { title: 'Forgot Password' },
    components: {
      LoadingButton,
      Logo,
      TextInput,
    },
    props: {
      errors: Object,
      canRegister: Boolean
    },
    data() {
      return {
        sending: false,
        otp_sent: false,
        submit_url: null,
        form: {
          mobile:null,
          otp: null,
          password: null,
          password_confirmation: null
        },
      }
    },
    methods: {
      submitForOtp() {
        this.sending = true
        this.$http.post(this.route('admin.password.reset.otp'), {
          mobile: this.form.mobile
        }).then((response) => {
          this.sending = false
          this.otp_sent = true;
          this.submit_url = response.data.url
        }).catch((res) => {
          if(res.response.status === 422) {
            this.$page.props.errors = res.response.data.errors;
            this.sending = false
          }
        })
      },

      verifyOTP() {
        this.sending = true
        this.$inertia.post(this.submit_url, {
          mobile: this.form.mobile,
          otp: this.form.otp,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
        },{
          onFinish : () => this.sending = false
        })
      }
    },
  }
</script>
